import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import * as DesktopNav from '@segment/matcha/recipes/Navigation/DesktopNavigation';
import NavDropdownBase, * as NavDropdown from '@segment/matcha/recipes/Navigation/DesktopNavigation/Dropdown';
import { usePageConfig } from '@segment/contexts/page';
import docsData from '../../data/docs';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

var Docs = function Docs() {
  var pageConfig = usePageConfig();

  var _docsData = docsData(pageConfig),
      content = _docsData.content,
      aside = _docsData.aside;

  return _jsxs(NavDropdownBase, {
    children: [_jsxs(NavDropdown.Content, {
      children: [_jsx(DesktopNav.Subheading, {
        children: content.title
      }), _jsxs(DesktopNav.List, {
        children: [content.links.map(function (item) {
          return _jsx("li", {
            role: "none",
            children: _jsx(DesktopNav.Link, {
              title: item.title,
              href: item.url
            })
          }, item.title);
        }), _jsx("li", {
          role: "none",
          children: _jsx(HighlightedLink, {
            title: content.highlightedLink.title,
            href: content.highlightedLink.url
          })
        })]
      })]
    }), _jsxs(NavDropdown.Tray, {
      children: [_jsx(DesktopNav.Subheading, {
        children: aside.title
      }), _jsx(DesktopNav.List, {
        children: aside.links.map(function (item) {
          return _jsx("li", {
            role: "none",
            children: _jsx(DesktopNav.Link, {
              title: item.title,
              description: item.description,
              href: item.url
            })
          }, item.title);
        })
      })]
    })]
  });
};

var HighlightedLink = /*#__PURE__*/_styled(DesktopNav.LinkHighlighted, true ? {
  target: "e10vqfck0"
} : {
  target: "e10vqfck0",
  label: "HighlightedLink"
})(true ? {
  name: "hkh81z",
  styles: "margin-top:8px"
} : {
  name: "hkh81z",
  styles: "margin-top:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default Docs;